import { render, staticRenderFns } from "./StockReceivedSummaryReportView.vue?vue&type=template&id=05b80973"
import script from "./StockReceivedSummaryReportView.vue?vue&type=script&lang=js"
export * from "./StockReceivedSummaryReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports